import { LRUCache } from "lru-cache";

const lruCacheOptions = {
  max: 500,
  ttl: 1000 * 60 * 60 * 24, // 1 day
};
const cache = new LRUCache(lruCacheOptions);

const fetchHandler = async ({
  url,
  cacheEnabled = false,
  clearCache = false,
  absoluteURL = false,
  method,
  headers,
  jwt = false,
  body,
}: {
  url: string;
  method: string;
  headers?: { [key: string]: string };
  body?: string;
  cacheEnabled?: boolean;
  clearCache?: boolean;
  absoluteURL?: boolean;
  jwt?: boolean;
}) => {
  try {
    if (clearCache) {
      cache.clear();
    }
    let token = "";

    if (jwt && typeof window !== "undefined" && localStorage.getItem("token")) {
      token = localStorage.getItem("token") || "";
    } else {
      token =
        "19a5c44e955035d2d18910a228840188524ada1877a8b02312ea0a4de33cd53b91b0d1c7183b811d22bba892958af40ea32be7a0513102172bd804223034710e8b8958718840b031fac7f511f577e3ba78a0e44a402cacf450bf05cf9b8f6c8337ce6cac514c7190d9735304481e2db015e4626461e88db110f2158ee260d11e";
    }

    const mainHeaders = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    let newURL = "";
    if (!absoluteURL) {
      // const baseUrl = "http://localhost:1337/api";
      const baseUrl = "https://gazar-b.fly.dev/api";
      newURL = `${baseUrl}${url}`;
    } else {
      newURL = url;
    }

    if (cacheEnabled && method === "GET") {
      const cachedResponse = await cache.get(newURL);
      if (cachedResponse) {
        return cachedResponse;
      }
    }

    const newOptions = {
      method,
    } as any;

    if (body) {
      newOptions.body = body;
    }

    newOptions.headers = {
      ...mainHeaders,
      ...headers,
    };

    const response = await fetch(newURL, newOptions);

    const data = await response.json();

    if (cacheEnabled && response.ok && method === "GET") {
      await cache.set(newURL, data);
    }

    return data;
  } catch (e) {
    console.log("e", e);
  }
};

export default fetchHandler;
